import { alpha, Theme } from '@mui/material'

const classes = {
  modalPaperStyle: (theme: Theme) => ({
    backgroundColor: theme.palette.ui.surfaceVariant,
  }),
  blurSkrim: (theme: Theme) => ({
    backgroundColor: alpha(theme.palette.ui.onPrimaryFixedVariant, 0.08),
    backdropFilter: 'blur(5px)',
    width: '100vw',
    height: '100vh',
    position: 'fixed',
  }),
}

export default classes
